import PropTypes from 'prop-types'
import PostTeaser from './post-teaser'

const PostTeaserList = ({ posts }) => {
  return posts && posts.length ? (
    <ul className="list-unstyled mbxl pbxl">
      {posts.map((post, idx) => (
        <li key={post.id} className={'pbxl'}>
          <PostTeaser post={post} bodyClassName="plm" index={idx} />
        </li>
      ))}
    </ul>
  ) : (
    <p className="mtl">
      There are currently no articles in this category. Check back soon!
    </p>
  )
}

PostTeaserList.propTypes = {
  posts: PropTypes.array,
}

export default PostTeaserList
